import { useNotification } from '@platform-ui/naive-ui'

export function useToast() {
  const notification = useNotification()
  
  return {
    success: (message, options = {}) => {
      return notification.success({
        content: message,
        duration: 3000,
        ...options
      })
    },
    
    error: (message, options = {}) => {
      return notification.error({
        content: message,
        duration: 5000,
        ...options
      })
    },
    
    warning: (message, options = {}) => {
      return notification.warning({
        content: message,
        duration: 4000,
        ...options
      })
    },
    
    info: (message, options = {}) => {
      return notification.info({
        content: message,
        duration: 3000,
        ...options
      })
    },
    
    // Generic toast method
    toast: (message, options = {}) => {
      return notification.info({
        content: message,
        duration: 3000,
        ...options
      })
    }
  }
}